// removed by extract-text-webpack-plugin
module.exports = {"stepTextBoxContainer":"stepTextBoxContainer__3WhzJ","boxUpperDiv":"boxUpperDiv__35Il-","boxLowerDiv":"boxLowerDiv__35kZh","stepNumberContainer":"stepNumberContainer__Z8_Po","separator":"separator__3Ox_H","textEnlarge":"textEnlarge__QG043","highlight":"highlight__1tzwD","stepNumberContainerHtb":"stepNumberContainerHtb__2DVLf"};


//////////////////
// WEBPACK FOOTER
// ./routes/program-landing-page/components/bic-steps/steps-text/step-text-box/style.css
// module id = VgqL
// module chunks = 380